module.exports = __webpack_public_path__ + "media/images/temp/icon-4-0c91f7e309943944eb4e3548ed33f7c3.png";